import React from "react";
import classNames from "classnames/bind";
import styles from "../ProfilePage.module.scss";
import OrdersList from "./OrdersList";

const cx = classNames.bind(styles);

const OrdersSection = ({
  orderHistory,
  isLoading,
  currentPage,
  currentTranslations,
  expandedShipping,
  expandedItems,
  onPageChange,
  toggleShippingInfo,
  toggleOrderItems,
  getStatusColor,
  getStatusText,
  getPaymentStatusText,
  getPaymentMethodText,
}) => {
  return (
    <div className={cx("orders-section")}>
      <div className={cx("section-header")}>
        <h2>{currentTranslations?.Profile?.my_orders}</h2>
        <span className={cx("order-count")}>
          {orderHistory?.total_orders || 0} {currentTranslations?.Order?.order_number}
        </span>
      </div>

      <OrdersList
        orderHistory={orderHistory}
        isLoading={isLoading}
        currentPage={currentPage}
        onPageChange={onPageChange}
        expandedShipping={expandedShipping}
        expandedItems={expandedItems}
        toggleShippingInfo={toggleShippingInfo}
        toggleOrderItems={toggleOrderItems}
        getStatusColor={getStatusColor}
        getStatusText={getStatusText}
        getPaymentStatusText={getPaymentStatusText}
        getPaymentMethodText={getPaymentMethodText}
      />
    </div>
  );
};

export default OrdersSection;
